<template>
  <div class="container">
    <div class="content">
      <about-banner></about-banner>
      <div class="artical">
        <div class="paragraph" :style="{
          marginTop: china ? '30px' : '70px'
        }">
          <div class="artical-title" v-html="lang.aboutGeelyFintech"></div>
          <div class="artical-content">
            <template v-for="(content, index) of lang.aboutGeelyFintechContents">
              <p v-if="(typeof content === 'string')" :key="index"> {{ content }} </p>
              <p v-else-if="content.type === 'list'" :key="index + '-list'">
              <ul>
                <li v-for="(item, j) of content.value" :key="j"> {{ item }} </li>
              </ul>
              </p>
            </template>
          </div>
        </div>
        <div class="paragraph">
          <div class="artical-title">
            {{ lang.aboutGeelyGroup }}
          </div>
          <div class="artical-content">
            <p v-for="(content, index) of lang.aboutGeelyGroupContents" :key="index">
              {{ content }}
            </p>
          </div>
        </div>
        <!-- <div class="paragraph">
          <div class="artical-title">{{ lang.aboutSAXOBankGroup }}</div>
          <div class="artical-content">
            <p v-for="(content, index) of lang.aboutSAXOBankGroupContents" :key="index">
              {{ content }}
            </p>
          </div>
        </div> -->
        <div class="paragraph">
          <div class="artical-title">{{ lang.contactUs }}</div>
          <div class="artical-content">
            <p @click="$routeChange('connection')">
              <img v-if="china" src="@/assets/home/contact-img.jpg" alt="connectUS" width="100%">
              <img v-else src="@/assets/en/contact-img.jpg" alt="connectUS" width="100%">
            </p>
          </div>
        </div>
        <div class="paragraph">
          <div class="artical-title">{{ lang.joinUs }}</div>
          <div class="artical-content">
            <!-- <p @click="$routeChange('join')">
              <img v-if="china" src="@/assets/home/joinus-img.jpg" alt="connectUS" width="100%"> 
              <img v-else src="@/assets/en/joinus-img.jpg" alt="connectUS" width="100%">
            </p> -->
            <p>
              <!-- <img v-if="china" src="@/assets/home/joinus-img.jpg" width="100%" alt="" /> -->
              <!-- <img v-else src="@/assets/en/joinus-img.jpg" width="100%" alt="" /> -->
              <img src="@/assets/home/joinus-img.jpg" width="100%" alt="" />
              <span>
                <a v-bind:href="joinUsSocialLink" target="_blank">
                  {{ lang.homePageJoin_1 }}<i class="iconfont iconLine23"></i>
                </a>
                <a v-bind:href="joinUsCampusLink" target="_blank">
                  {{ lang.homePageJoin_2 }}<i class="iconfont iconLine23"></i>
                </a>
              </span>
            </p>
          </div>
        </div>
      </div>
      <page-footer></page-footer>
    </div>
  </div>
</template>

<script>
import mapStore from '@/mixins/mapStore'
export default {
  mixins: [
    mapStore('', {
      getters: ['lang', 'china']
    })
  ],
  data() {
    return {
      joinUsSocialLink: process.env.VUE_APP_MOKA_SOCIAL_LINK || '/join',
      joinUsCampusLink: process.env.VUE_APP_MOKA_CAMPUS_LINK || '/join'
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  padding-top: 52px;
}

.artical {
  background: white;
  padding: 70px 15px 10px;
}

.paragraph {
  margin-top: 30px;

  .artical-title {
    font-size: 18px;
    font-weight: 500;
  }

  .artical-title::after {
    content: "/";
    display: inline-block;
    font-weight: 500;
    font-size: 18px;
    margin-left: 10px;
  }

  .artical-content {
    p {
      margin-top: 20px;
      line-height: 28px;
      font-size: 15px;
      color: #3D434D;
      text-align: justify;
      position: relative;

      span {
        display: block;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: -56px;
        margin-left: -59px;
      }

      a {
        display: block;
        font-size: 14px;
        text-align: center;
        color: #fff;
        height: 38px;
        line-height: 38px;
        border: 1px solid #fff;
        box-sizing: border-box;
        padding-left: 20px;
        padding-right: 15px;
        margin: 10px 0;

        i {
          line-height: 38px;
          font-size: 12px;
          color: #fff;
          margin-left: 2px;
        }
      }
    }
  }
}
</style>
